<template>
    <div>
        <ui-modal 
            title="Add Estimate"
            ref="modal"
            dismiss-on="close-button"
        >
            <div class="container-fluid" style="padding: 0; margin-top: 1.5rem;">
                <div class="row">
                    <div class="col">
                        <ui-textbox
                            label="Description"
                            v-model="item.description"
                            :disabled="isSaving"
                        ></ui-textbox>
                    </div>
                    <div class="col-3">
                        <ui-textbox
                            label="Cost £'s"
                            v-model="item.unit_cost"
                            type="number"
                            step="5"
                            :disabled="isSaving"
                        ></ui-textbox>
                    </div>
                </div>
            </div>

            <div slot="footer">
                <ui-button
                    color="green"
                    @click="save()"
                    :loading="isSaving"
                    :disabled="!canSave"
                >
                    Save
                </ui-button>
            </div>
        </ui-modal>
    </div>
</template>

<script>
    import { ExpenseItemSchema } from '../../../classes/Api/Expense'
    import { TaskResource } from '../../../classes/Api/Task'
    import { VatTariffs } from '../../../classes/VatService'

    export default {
        props: {
            task: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                item: new ExpenseItemSchema(),
                isSaving: false
            }
        },
        computed: {
            canSave() {
                return (
                    this.item.unit_cost > 0 && this.item.description.length > 0
                )
            }
        },
        methods: {
            open() {
                this.reset();
                this.$refs.modal.open();
            },
            reset() {
                this.item = new ExpenseItemSchema({
                    expense_category_id: window.marque.ui.defaultNonAccountableExpenseCategory.id,
                    vat_rate: VatTariffs.NONE,
                    quantity: 1,
                })

                this.isSaving = false
            },
            save() {
                this.isSaving = true

                TaskResource.createAndAttachInternalCost(this.task.id, this.item).then(response => {
                    this.isSaving = false
                    this.$emit('saved', response.data)
                    this.$refs.modal.close();
                }, e => { this.isSaving = false; handleApiError(e); })
            }
        }
    }
</script>